import type { AppPort } from "./types";

/** 웹: 탭이 다시 보이면 포그라운드 복귀로 본다(0.5 백그라운드 복귀 규칙을 같은 훅으로 태운다). */
export const webApp: AppPort = {
  onForeground(cb) {
    const onVisible = () => {
      if (document.visibilityState === "visible") cb();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  },
  // 웹은 빌드 번호가 없다. 버전은 vite define(__APP_VERSION__ = package.json version).
  async getInfo() {
    return { version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0", build: null };
  },
  // 브라우저 뒤로가기는 history가 처리한다(react-router popstate).
  onBackButton() {
    return () => undefined;
  },
  async exit() {},
  async hideSplash() {},
  // 웹은 URL 이 곧 라우트라 따로 받을 것이 없다
  onOpenUrl() {
    return () => undefined;
  },
};
